import * as React from "react";
import { Box, Heading, Stack } from "@origin-digital/ods-core";
import { IconChevronRight } from "@origin-digital/ods-icons";

import content from "../../cms/highlightedArticles.json";
import { StyledLink } from "../../helpers/styles";
import { HighlightedArticles } from "./HighlightedArticles";

export interface IQuickLink {
  title: string;
  icon: React.ReactNode;
  link: string;
  uri: string;
  order: number;
}

export const QuickLink = ({ title, icon, link, uri }: IQuickLink) => {
  // check for highlighted articles
  const highlightedArticleList = content.find(
    (qlItem) => qlItem.collection === uri
  );

  return (
    <Box
      data-id="quicklink-container"
      display="flex"
      paddingRight={{ xs: "none", sm: "xlarge", lg: "xxlarge" }}
      paddingBottom={{ xs: "medium", sm: "xlarge", lg: "xxlarge" }}
    >
      <Box paddingRight="medium">{icon}</Box>
      <Stack space="medium">
        <Heading component="h3" variant="h4">
          <StyledLink to={link}>
            {title}
            <Box display="inline" position="absolute">
              <IconChevronRight color="critical" />
            </Box>
          </StyledLink>
        </Heading>

        {highlightedArticleList && highlightedArticleList.items && (
          <HighlightedArticles
            categoryUri={uri}
            items={highlightedArticleList.items}
            categoryTitle={title}
          />
        )}
      </Stack>
    </Box>
  );
};
